import React from 'react';
import useIsMobile from 'app/utils/hooks/useIsMobile';
import EngagementBarLayout from 'app/components/post/EngagementBarLayout';
import { MessageCircle, Share2 as Share, MoreHorizontal } from 'react-feather';
import { Button, Dropdown } from 'app/seedly-component-library';
import { UPVOTER_TYPE, SAVE_TYPE } from 'app/constants/app';
import { generatePostLink } from 'app/utils/generateShareLink';
import BookmarkButton from 'app/components/post/BookmarkButton';
import Reactions from 'app/components/post/Reactions';
import useShareMenu from 'app/utils/hooks/useShareMenu';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import styled from 'styled-components';
import usePostMenu from '../hooks/usePostMenu';

const StyledMessageCircle = styled(MessageCircle)`
  margin-right: ${props => props.theme.spacing.xs};
`;

const EngagementBar = props => {
  const { post } = props;
  const { id, post: postData = {}, group = {} } = post;
  const { upvoted, upvotesCount } = postData;

  const shareUrl = generatePostLink(post.slug);
  const postMenu = usePostMenu({ postProps: post });
  const isMobile = useIsMobile();
  const shareMenu = useShareMenu(shareUrl);

  return (
    <EngagementBarLayout
      commentsCount={post.discussionCommentsCount}
      commentButton={
        isMobile ? (
          <a
            href={`/posts/${post.slug}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <StyledMessageCircle size={20} />
          </a>
        ) : (
          <StyledMessageCircle size={20} />
        )
      }
      shareButton={
        <Dropdown
          items={shareMenu}
          handleSelectedItemchange={item => {
            item.selectedItem.onClick();
          }}
          menuAlign="left"
          button={
            <Button
              size="md"
              variant="ghost"
              data-testid="button-share-options"
              onClick={() => {
                mixpanel.track(trackedEvents.CommentThread, {
                  param: 'share',
                  category: 'post',
                });
              }}
              icon={<Share />}
            />
          }
        />
      }
      bookmarkButton={
        <BookmarkButton
          contentId={id}
          saved={post.bookmarked}
          type={SAVE_TYPE.POST}
          onClickTrack={() => {
            mixpanel.track(trackedEvents.CommentThread, {
              param: 'bookmark',
              category: 'post',
            });
          }}
        />
      }
      reactionButton={
        group?.slug === 'promo-codes' ? null : (
          <Reactions
            id={id}
            upvoted={upvoted}
            upvoteCount={upvotesCount}
            type={UPVOTER_TYPE.POST}
          />
        )
      }
      menuButton={
        postMenu.length > 0 && (
          <Dropdown
            items={postMenu}
            handleSelectedItemchange={item => {
              item.selectedItem.onClick();
            }}
            menuAlign="right"
            button={
              <Button
                size="md"
                variant="ghost"
                data-testid="menu-options"
                onClick={() => {
                  mixpanel.track(trackedEvents.CommentThread, {
                    param: 'three_dot_menu',
                    category: 'post',
                  });
                }}
                icon={<MoreHorizontal />}
              />
            }
          />
        )
      }
    />
  );
};

export default EngagementBar;
